import { useState, useEffect } from 'react';

/**
 * A hook for debouncing a value for an amount of time.
 * `delay` defaults to 500 milliseconds. Negative numbers are ignored.
 *
 * @param value T
 * @param delay number | undefined
 * @returns T
 */ const useDebounce = (value, delay = 500)=>{
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(()=>{
        // no setTimeout is needed if the delay is 0 (or less)
        // has the benefit of playing nice with @testing-library/react and jsdom
        if (delay > 0) {
            const timer = setTimeout(()=>setDebouncedValue(value), delay);
            return ()=>{
                clearTimeout(timer);
            };
        } else {
            setDebouncedValue(value);
            return;
        }
    }, [
        value,
        delay
    ]);
    return debouncedValue;
};

export { useDebounce };
//# sourceMappingURL=use-debounce.js.map
